import React from 'react';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { mobilenoblack, secondaryTextGray } from '../../../theme/palette';
import { useMediaQuery } from '@mui/material';
import { CrossIcon } from '../../../assets/images';
var serviceHistry = function (props) {
    var handleDrawerClose = props.handleDrawerClose;
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var serviceHistryData = [{
            type: FormItemTypes.ContainerItem,
            name: 'header',
            label: '',
            flexDirection: 'row',
            columnSize: 12,
            marginTop: IS_DESKTOP ? 8 : 0,
            justifyContent: 'space-between',
            padding: '20px 0px',
            spacing: 0,
            rowSpacing: 3,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'header',
                    label: 'More Details',
                    columnSize: 11,
                    labelTypographyProps: {
                        variant: 'h1',
                        color: mobilenoblack,
                        paddingX: '24px'
                    }
                }, {
                    type: FormItemTypes.IconButton,
                    name: 'Close',
                    columnSize: 1,
                    size: 'large',
                    children: /*#__PURE__*/ React.createElement("img", {
                        id: "crossIconBtn",
                        color: secondaryTextGray,
                        src: CrossIcon
                    }),
                    sx: {
                        padding: ' 0px 24px 0px 0px'
                    }
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: serviceHistryData
    }));
};
export default serviceHistry;
